import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Optional} from "@angular/core";
import {animate, keyframes, style, transition, trigger} from "@angular/animations";
import {IMessageToastParams} from "../IMessageToastParams";
import {MessageToastType} from "../MessageToastType";
import {ToastInstance} from "../ToastInstance";
import {INToastLang, N_TOAST_LANG} from "../toastLang";


// noinspection TsLint
@Component({
  selector: "n-modern-toaster",
  styleUrls: ["./n-modern-toaster.css"],
  animations: [
    trigger("toast", [

      transition("void => in", [
        animate("200ms ease", keyframes([
          style({opacity: 0, transform: "translate(0, 25%)"}),
          style({opacity: 1, transform: "translate(0, 12.5%)"}),
          style({opacity: 1, transform: "translate(0, 0)"}),
        ]))
      ]),

      transition("in => void", [
        animate("150ms ease", keyframes([
          style({opacity: 1, transform: "translate(0, 0)"}),
          style({opacity: 1, transform: "translate(0, -50%)"}),
          style({opacity: 0, transform: "translate(0, -100%)"}),
        ]))
      ])

    ])
  ],
  template: `
    <div class="container" *ngFor="let toast of toasts" [@toast]="'in'">
      <div class="toast" [ngClass]="{'-danger': toast.type === 3}">
        <span class="text">{{toast.text}}</span>
        <span class="buttons" *ngIf="toast.type === 2">
          <button class="action-button" *ngIf="toast.onShowMore" type="button" (click)="toast.onShowMore()"
                  tid="toast-showmore-button">{{lang.showMoreName}}</button>
          <button class="action-button" type="button" (click)="onCancel(toast)" tid="toast-cancel-button">{{lang.cancelName}}</button>
        </span>
        <a class="action-button" *ngIf="toast.type === 3 && toast.emergencyLink" [href]="toast.emergencyLink" target="_blank"
           (click)="toast.instance.close()">{{lang.getHelpName}}</a>
        <button class="close-button" *ngIf="toast.type === 2 || toast.type === 3" type="button" (click)="toast.instance.close()"
                tid="toast-close-button"></button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NModernToasterComponent {
  lang: INToastLang;
  toasts: ToastInfo[] = [];

  constructor(private cd: ChangeDetectorRef, @Inject(N_TOAST_LANG) @Optional() lang: INToastLang) {
    this.lang = lang;
  }

  onCancel(toast: ToastInfo) {
    toast.onCancel();
    toast.instance.close();
  }

  showToast(options: IMessageToastParams): ToastInstance {
    if (options.uniqueId && this.toasts.find(toast => toast.uniqueId === options.uniqueId)) {
      return;
    }

    this.toasts.push({
      ...options,
      instance: new ToastInstance(options.text, options.type, (instance) => {
        const index = this.toasts.findIndex(item => item.instance === instance);
        if (index >= 0) {
          this.toasts.splice(index, 1);
          this.cd.detectChanges();
        }
      })
    });
    this.cd.detectChanges();

    this.toasts.forEach((toast, index) => {
      if (index !== this.toasts.length - 1) {
        toast.instance.close();
      }
    });

    return this.toasts[this.toasts.length - 1].instance;
  }

}

export interface ToastInfo {
  instance: ToastInstance;
  type: MessageToastType;
  text: string;
  uniqueId: string;
  emergencyLink: string;
  onCancel: () => void;
  onShowMore: () => void;
}
